import { call, put } from "redux-saga/effects";
import { reviewApi } from "@services/api";
import { checkUserReviewActions } from "../slices";

function* checkUserReviewWorker({ payload }) {
  try {
    yield put(checkUserReviewActions.pending());
    const response = yield call(reviewApi.checkUserReview, payload);
    yield put(checkUserReviewActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(checkUserReviewActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { checkUserReviewWorker };
